import { Button, DownloadIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";
import { useDownloadLogJob } from "../../hooks/logs/useDownloadLogJob";
import { generateLogJobDownloadFilename } from "../../helper/logHelper";

type LogJobDownloadButtonProps = {
  logId: string;
  jobId: string;
};

export const LogJobDownloadButton: React.FC<LogJobDownloadButtonProps> = ({
  logId,
  jobId,
}) => {
  const { t } = useTranslation();
  const [downloadLogJob, isLoading] = useDownloadLogJob(logId, jobId);
  const filename = generateLogJobDownloadFilename(logId, jobId);

  return (
    <Button
      key="log-job-download"
      icon={<DownloadIcon />}
      size="small"
      onClick={async () => {
        const blob = await downloadLogJob();

        if (blob) {
          saveAs(blob, filename);
        }
      }}
      loading={isLoading}
    >
      {t("log_jobs_list.actions.download.button")}
    </Button>
  );
};
